<div class="container-fluid">

    <div class="row gutter-xl">

        <div class="col-auto">
            <i class="fa-solid fa-traffic-light-stop error-icon"></i>
        </div>

        <div class="col-md col-sm-12">
            <h1>{{'permissions.errors.no_permission_header' | translate}}</h1>

            <p>
                {{'permissions.errors.no_permissions_description' | translate: {user: (user | async).name } }}
            </p>

            <div class="row gutter-xs">
                <div class="col-auto">
                    <button type="button" class="btn btn-primary" (click)="goBack()">
                        {{'common.actions.back' | translate}}
                    </button>
                </div>

                <div class="col-auto">
                    <a [routerLink]="['/']" class="btn btn-outline-primary">
                        {{'store.errors.to_frontpage' | translate}}
                    </a>
                </div>
            </div>

        </div>
    </div>

</div>